// Historical status is a read projection, independent of permission to close.
const yearClosingHistory = (state: any, currentYear: number, statusForYear: (state: any, year: number) => any) => {
  const years = new Set<number>();
  [state.closedYearsByYear, state.yearClosingProcessByYear, state.deadlinesByYear,
    state.taxReturnProcessByYear, state.annualAccountsProcessByYear]
    .forEach((byYear) => Object.keys(byYear || {}).forEach((year) => years.add(Number(year))));
  return [...years].filter((year) => Number.isInteger(year) && year > 1900 && year < currentYear)
    .map((year) => ({ year, ...statusForYear(state, year) }))
    .filter((entry) => entry.yearClosed || entry.taxFiled || entry.annualAccountsFiled)
    .sort((a, b) => b.year - a.year);
};
